/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type BillingEventHistoryOriginEnum = 'SERVICE_PLANE' | 'OPERATOR';

export const BillingEventHistoryOriginEnum = {

    SERVICE_PLANE: 'SERVICE_PLANE' as BillingEventHistoryOriginEnum,

    OPERATOR: 'OPERATOR' as BillingEventHistoryOriginEnum
};

